import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./wait-box.html";

class WaitBoxComponent extends Component {
	constructor () {
		super("waitBoxComponent");
		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (!this.modal) {
			this.modal = new Modal(document.querySelector("#waitBoxModal"));
		}
	}
	
	close () {
		this?.modal?.hide();
		
		const body = document.querySelector("body");
		body.classList.remove("wait-box-open");

		Shark.set({
			waitBoxCustomMessage: "",
		});
	}
	
	init () {
		Shark.set({
			waitBoxCustomMessage: "",
		});
	}
	
	open () {
		document.querySelector("body").classList.add("wait-box-open");
		this?.modal?.show();
	}

	setCustomMessage (message) {
		Shark.set({
			waitBoxCustomMessage: message,
		});

		console.log("waitBoxCustomMessage", Shark.$store.waitBoxCustomMessage);
	}
}

const waitBoxComponent = new WaitBoxComponent();

Shark.registerComponent(waitBoxComponent);

export default waitBoxComponent;
